import { useState } from 'react';
import { Chess } from 'chess.js';
import ChessBoard from '../ChessBoard';
import { Button, ButtonGroup, Alert } from 'react-bootstrap';

function ReplayView({ replayData, settings, onBack }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [game, setGame] = useState(new Chess());
  const [error, setError] = useState(null);

  const goToStep = (step) => {
    setError(null);

    if (step === 0) {
      setGame(new Chess());
      setCurrentStep(0);
      return;
    }

    const moveData = replayData.moves[step - 1];

    if (moveData && moveData.fen) {
      try {
        const fenGame = new Chess(moveData.fen);
        setGame(fenGame);
        setCurrentStep(step);
        return;
      } catch { }
    }

    try {
      const newGame = new Chess();
      for (let i = 0; i < step; i++) {
        const m = replayData.moves[i];
        const result = newGame.move(m.san || m);
        if (!result) throw new Error(`Invalid move: ${m.san || m}`);
      }
      setGame(newGame);
      setCurrentStep(step);
    } catch {
      setError(`Could not show position (step ${step}). The saved replay may be incomplete.`);
    }
  };

  const getPieceFullName = (shortType) => {
    const names = { p: 'pawn', n: 'knight', b: 'bishop', r: 'rook', q: 'queen', k: 'king' };
    return names[shortType];
  };

  const visualBoard = game.board().map((row) =>
    row.map((piece) => (piece ? { type: getPieceFullName(piece.type), color: piece.color === 'w' ? 'white' : 'black' } : null))
  );

  return (
    <div className="d-flex flex-column align-items-center w-100 h-100 p-3">
      <div className="mb-2 text-center text-white">
        <h6 className="mb-0 text-light-green">Replaying Match</h6>
        <small className="text-muted">{replayData.date}</small>
      </div>

      {error && <Alert variant="danger" className="py-1 small">{error}</Alert>}

      <div className="flex-grow-1 d-flex align-items-center justify-content-center w-100" style={{ minHeight: 0 }}>
        <ChessBoard board={visualBoard} settings={settings} onSquareClick={() => { }} />
      </div>

      <div className="mt-3 bg-dark p-3 rounded w-100 text-center text-white border border-secondary">
        <div className="mb-2 fw-bold">Step: {currentStep} / {replayData.moves.length}</div>
        <ButtonGroup className="w-100 mb-3">
          <Button variant="secondary" onClick={() => goToStep(0)} disabled={currentStep === 0}>«</Button>
          <Button variant="secondary" onClick={() => goToStep(currentStep - 1)} disabled={currentStep === 0}>‹</Button>
          <Button variant="secondary" onClick={() => goToStep(currentStep + 1)} disabled={currentStep === replayData.moves.length}>›</Button>
          <Button variant="secondary" onClick={() => goToStep(replayData.moves.length)} disabled={currentStep === replayData.moves.length}>»</Button>
        </ButtonGroup>
        <div className="d-grid">
          <Button variant="outline-danger" size="sm" onClick={onBack}>Close Replay</Button>
        </div>
      </div>
    </div>
  );
}

export default ReplayView;